import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { useHistory } from 'react-router-dom';
import TopNav from 'components/TopNav';
import BottomNav from 'components/BottomNav';
import styles from './style.module.scss';
import ErrorMessage from 'common/error';
import * as profileApi from 'api/profile';
import * as changePhoneHistoryApi from 'api/changePhoneHistory';

function Changephone() {
  const history = useHistory();
  const [phone, setPhone] = useState('');
  const [visible, setVisible] = useState(false);
  const [messageErr, setMessageErr] = useState();

  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        setVisible(false);
      }, 3000);
    }
  }, [visible]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (phone === '') {
      setAlertMessage(ErrorMessage.validate_phone);
      return;
    } else {
      const checkIsMemberExist = await profileApi.checkIsPhoneExist(phone);
      if (checkIsMemberExist.success === false) {
        setAlertMessage(checkIsMemberExist.message);
        return;
      }

      if (window.confirm('携帯電話番号を変更しますか？')) {
        let result = phone;
        // if (phone.charAt(0) === '0') {
        //   result = phone.replace(phone.charAt(0), '+81');
        // } else {
        //   result = '+81' + phone;
        // }
        let data = {
          phone: result,
        };
        try {
          await profileApi.updatePhone(data);
          history.push({ pathname: `${process.env.RAZZLE_PUBLIC_URL}/verify-code-change-phone/${result}` });
        } catch (e) {
          setAlertMessage(e.response?.data?.message);
        }
      }
    }
  };

  const setAlertMessage = (message) => {
    setMessageErr(message);
    setVisible(true);
  };

  return (
    <div style={{ overflow: 'auto', height: '100vh' }}>
      <div style={{ maxWidth: 560, margin: 'auto' }}>
        <TopNav name={`登録電話番号変更`} hasBackIcon={true} />
        <div className={`${styles.changePhone} align-top`}>
          <form onSubmit={handleSubmit}>
            <div className={styles.back_white_wrap}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className="align-center mb-heading">
                  <span className="stick-icon">&nbsp;</span>
                  <span className="title font-4">登録電話番号の変更</span>
                </div>
              </div>
              <div>
                <span className="title font-3">
                  新しい携帯電話番号を入力してください。
                  <br />
                  すでに登録済みの携帯番号へは変更できません。
                </span>
              </div>

              <div className={styles.divInputOne}>
                <span className="font-2">電話番号</span>
                <input
                  id="name"
                  type="number"
                  name="phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="登録した電話番号を入力して下さい"
                />
              </div>

              <br />
              <center>
                <div id="sign-in-button"></div>
              </center>
              <div className={styles.divSubmit}>
                <div className="btn-main btn-submit" onClick={handleSubmit}>
                  次へ
                </div>
              </div>
            </div>
          </form>

          <Dialog
            open={visible}
            onClose={() => setVisible(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            style={{ opacity: 0.6 }}
          >
            <DialogContent style={{ backgroundColor: 'var(--black)' }} onClick={() => setVisible(false)}>
              <span style={{ color: 'var(--white)', fontWeight: 'bold' }}>{messageErr}</span>
            </DialogContent>
          </Dialog>
        </div>
        <BottomNav />
      </div>
    </div>
  );
}

export default Changephone;
